import { LANGUAGES } from '@/utils/translation';
import Cookies from 'js-cookie';
import { useEffect } from 'react';

export default function useLangSwitcher(args: {
  lang?: string;
  route?: string;
}) {
  const lang = args.lang || 'en';

  const setCookiesLang = () => {
    Cookies.set('language', lang);
  };

  useEffect(() => {
    setCookiesLang();
  }, [args.route]);

  const getLangLink = (langItem: string) => {
    const [, path] = window.location.href.split(window.location.origin);

    const hasLocaleInPathname = LANGUAGES.some(
      (locale) => path.startsWith(`/${locale}/`) && path !== `/${locale}`,
    );

    if (hasLocaleInPathname) {
      return path.replace(/\/[a-z]{2}\//, `/${langItem}/`);
    }
    return path;
  };

  return {
    lang,
    getLangLink,
  };
}
